import axios from 'axios'
import iView from 'iview'

// 会话超过 60 分钟没有用户活动时，前端清理登录态并回到登录页。
export const SESSION_IDLE_TIMEOUT = 60 * 60 * 1000
export const SESSION_LAST_ACTIVE_KEY = 'userLastActiveAt'
const SESSION_ACTIVITY_EVENTS = ['mousedown', 'keydown', 'touchstart', 'scroll']

axios.defaults.headers['Access-Control-Allow-Origin'] = '*'
axios.defaults.timeout = 600000
axios.defaults.baseURL = '/api/'

function readSessionUser () {
  const userDataJSON = sessionStorage.getItem('userData')
  if (!userDataJSON) {
    return null
  }
  try {
    return JSON.parse(userDataJSON)
  } catch (e) {
    return null
  }
}

/** 记录最近一次登录或用户操作时间；没有登录态时不写入时间戳。 */
export function touchSessionActivity () {
  if (sessionStorage.getItem('userData')) {
    sessionStorage.setItem(SESSION_LAST_ACTIVE_KEY, String(Date.now()))
  }
}

export function clearSession () {
  sessionStorage.removeItem('userData')
  sessionStorage.removeItem(SESSION_LAST_ACTIVE_KEY)
}

export function isSessionExpired () {
  if (!readSessionUser()) {
    return false
  }
  const lastActiveAt = Number(sessionStorage.getItem(SESSION_LAST_ACTIVE_KEY))
  // 旧版本没有时间戳时，从本次检测开始计时，避免已登录用户被突然登出。
  if (!Number.isFinite(lastActiveAt) || lastActiveAt <= 0) {
    touchSessionActivity()
    return false
  }
  return Date.now() - lastActiveAt >= SESSION_IDLE_TIMEOUT
}

/**
 * 检查当前页面会话并在过期时统一清理、跳转。
 * 请求拦截和页面定时器都会调用它，保证无操作过期与下一次请求过期的行为一致。
 */
export function ensureSessionActive (vm, recordActivity = false) {
  if (!sessionStorage.getItem('userData')) {
    return true
  }
  if (!isSessionExpired()) {
    if (recordActivity) {
      touchSessionActivity()
    }
    return true
  }
  clearSession()
  if (vm && vm.$Message) {
    vm.$Message.warning('登录已超过60分钟无操作，请重新登录')
  }
  if (vm && vm.$router && (!vm.$route || vm.$route.path !== '/')) {
    vm.$router.replace({path: '/'})
  }
  return false
}

/**
 * 在登录后的页面监听用户活动并定期检查过期状态，返回值用于页面销毁时移除监听。
 */
export function startSessionGuard (vm) {
  if (!sessionStorage.getItem('userData')) {
    return () => {}
  }
  const handleActivity = () => touchSessionActivity()
  let timer = null
  const stop = () => {
    if (timer !== null) {
      window.clearInterval(timer)
      timer = null
    }
    SESSION_ACTIVITY_EVENTS.forEach(eventName => window.removeEventListener(eventName, handleActivity))
  }
  timer = window.setInterval(() => {
    if (!ensureSessionActive(vm)) {
      stop()
    }
  }, 60 * 1000)
  SESSION_ACTIVITY_EVENTS.forEach(eventName => window.addEventListener(eventName, handleActivity, {passive: true}))
  ensureSessionActive(vm)
  return stop
}

// 添加请求拦截器
axios.interceptors.request.use(
  config => { // 在发送请求之前做些什么
    config.data = JSON.stringify(config.data)
    const userData = readSessionUser()

    config.headers = {
      'Content-Type': 'application/json;charset=UTF-8',
    }
    if (userData) {
      config.headers['token'] = userData.id
      config.headers['role-code'] = userData.roleCode
      config.headers['user-code'] = userData.userCode
    }
    iView.LoadingBar.start()
    return config
  }, error => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 添加响应拦截器
axios.interceptors.response.use(
  response => { // 对响应数据做点什么
    iView.LoadingBar.finish()
    return response;
  },
  err => { // 对响应错误做点什么
    console.error(err)
    iView.LoadingBar.finish()
    return Promise.reject(err)
  }
)

function urlencoded(body) { // 过滤空数据
  for (let item in body) {
    if (typeof body[item] === 'string') {
      body[item] = _.trim(body[item])
    }
    if (body[item] === '') {
      // delete body[item]
    }
  }
  return body
}

export function fetch(url, data = {}, method = 'GET') {
  // console.log('callApi:data', data)
  if (!ensureSessionActive(this, true)) {
    return Promise.reject({sessionExpired: true})
  }
  if (process.env.NODE_ENV === 'development') { // 本地请求均为get
    // method = 'GET'
  }
  let reqDefaultOpts = {
    method: method,
    url: url,
    params: urlencoded(data),
    data: urlencoded(data)
  }
  if (method == 'GET') {
    delete reqDefaultOpts.data
  } else {
    delete reqDefaultOpts.params
  }
  return new Promise((resolve, reject) => {
    axios(reqDefaultOpts).then(response => {
      if (!response.data.reFlag) {
        this.$Message.error(response.data.message)
        reject(response.data)
        return false
      }
      // console.log(response.data)
      resolve(response.data)
    }).catch(error => {
      reject(error)
      this.$Message.error('连接超时~')
    })
  })
}
